module.exports = __webpack_public_path__ + "r-v3/img/ico_logout_white.1b92f895.svg";